import { render, staticRenderFns } from "./changPassword.vue?vue&type=template&id=0868767e&scoped=true"
import script from "./changPassword.vue?vue&type=script&lang=js"
export * from "./changPassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0868767e",
  null
  
)

export default component.exports